import {
  Button,
  DatePicker,
  Select,
  Skeleton,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  formatDateAndTime,
  getLocalStorageItem,
  trimString,
} from "../../../Utils";
import {
  getBbpsReport,
  getmemberFilterList,
} from "../../../ApiServices/Apifun";
import dayjs from "dayjs";
import ReportDrawer from "../../../Common/ReportDrawer";
import { AiOutlineSearch } from "react-icons/ai";
import Content from "../../../Common/ReceiptContent";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch, useSelector } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";
import { FaEye } from "react-icons/fa6";
import axios from "axios";
import { APIURL } from "../../../ApiServices/Axios";
import { Globalendpoints } from "../../../ApiServices/global";
import CommonAmountPage from "../../../Common/CommonAmountPage";

const BbpsReport = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [totalAmt, setTotalAmt] = useState();
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [memberTypeFilter, setMemberTypeFilter] = useState(null);
  const [memberOptions, setMemberOptions] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const [searchdropdown, setSearchdropdown] = useState(null);
  const [amountData, setAmountData] = useState({});
  const dropdown = [
    {
      label: "Successful",
      value: "1",
    },
    {
      label: "Pending",
      value: "0",
    },
    {
      label: "Failed",
      value: "2",
    },
  ];
  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => (
        <p className="font-medium w-[150px]">{formatDateAndTime(text)}</p>
      ),
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Member Id",
      dataIndex: "member_id",
      key: "member_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Member Mobile",
      dataIndex: "member_mobile",
      key: "member_mobile",
      render: (text) => <p className="w-[200px]">{text}</p>,
    },
    {
      title: "Service Type",
      dataIndex: "service_type",
      key: "service_type",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text ? text : "-"}
        </p>
      ),
    },
    {
      title: "Biller Name",
      dataIndex: "biller_name",
      key: "biller_name",
      render: (text) => <p className="w-[200px]">{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        return (
          <>
            {text === "1" ? (
              <Tag color="green">Success</Tag>
            ) : text === "2" ? (
              <Tag color="red">Failed</Tag>
            ) : (
              <Tag color="yellow">Pending</Tag>
            )}
          </>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[130px]  overflow-y-scroll">
              {text ? text + " " + "Rs." : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[100px]  px-3 overflow-y-scroll">
                {text ? trimString(text) : "-"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "View Receipt",
      dataIndex: "view",
      key: "view",
      render: (text, record) => {
        return (
          <div
            className="border border-gray-300 p-2 flex justify-center items-center rounded-md cursor-pointer"
            onClick={() => {
              setResult({
                data: {
                  Date: record.Date,
                  "Member Mobile": record.member_mobile,
                  "Service Type": record.service_type,
                  "Biller Name": record.biller_name,
                  Amount: record.amount,
                  Remark: record.remark,
                },
                transaction_id: record.transaction_id,
              });
              setOpenReceiptDrawer(true);
            }}
          >
            <FaEye />
          </div>
        );
      },
    },
  ];

  const getReport = (
    search_keyword = searchdropdown || searchKeyword,
    search_column = searchcolumn,
    status = searchdropdown,

    from_date = fromDate,
    filter_member_id = memberTypeFilter ?? "",
    to_date = toDate,
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: status,

      search_keyword: search_keyword,
      search_column: search_column,
      filter_member_id: filter_member_id,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getBbpsReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setTotalAmt(res.total_amount);
        setAmountData(res);
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          }),
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  const getMemberFilter = () => {
    getmemberFilterList()
      .then((res) =>
        setMemberOptions(
          res.data.map((i, index) => {
            return {
              label: i.display_text,
              value: i.id,
              mobile: i.mobile,
              key: i.id,
            };
          }),
        ),
      )
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getReport();
  }, [current, pageSize, memberTypeFilter]);
  useEffect(() => {
    dispatch(setselectedTab("11.6"));
    profiledetail.member_type !== "Retailer" && getMemberFilter();
  }, []);
  console.log(amountData);

  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">BBPS Report</p>

            <div className="flex gap-2">
              <p
                onClick={() => {
                  const formdata = new FormData();
                  formdata.append("is_export", 1);
                  formdata.append("per_page", pageSize);
                  formdata.append("page_no", current);
                  axios
                    .post(
                      APIURL + Globalendpoints.bbpsreport, // Replace with your actual POST endpoint

                      formdata,
                      {
                        responseType: "blob", // Important for binary files
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
                        },
                      },
                    )
                    .then((res) => {
                      // Determine file type or use default
                      const blob = new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      saveAs(blob, "bbpsreport.xlsx");
                    })
                    .catch((err) => {
                      console.error("Download failed:", err);
                    });
                }}
                className="font-medium text-xs cursor-pointer bg-bsgreen hover:bg-green-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
              >
                Export
              </p>
              <p
                onClick={() => {
                  getReport("", "", "", "");
                  setSearchKeyWord("");
                  setSearchColumn(null);
                  setMemberTypeFilter(null);
                  setSearchdropdown(null);

                  setFromDate("");
                  setToDate("");
                }}
                className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
              >
                Clear Filter
              </p>
            </div>
          </div>
          <div
            className={`selectionFields grid grid-cols-1 gap-4 place-items-center 
  ${
    profiledetail.member_type !== "Retailer"
      ? "md:grid-cols-4"
      : "md:grid-cols-3"
  }
`}
          >
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              <p className={`required text-textGray `}>Keyword</p>
              {searchcolumn === "bbps.created_at" ? (
                <DatePicker
                  // value={dayjs("2023-09-07","YYYY-MM-DD")}
                  popupClassName="bottom-calendar"
                  allowClear
                  // value={searchKeyword}
                  className="w-full datepicker mt-4"
                  onChange={(val) =>
                    setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                  }
                  placement="bottomLeft"
                  placeholder="Search"
                />
              ) : (
                <CommonInput
                  placeholder="Seacrh"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyWord(e.target.value)}
                  className="outline-none text-xs border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
                />
              )}
            </div>
            {profiledetail.member_type !== "Retailer" && (
              <div className="w-full">
                <p className={`required text-textGray mt-2`}>
                  Select Member Type
                </p>
                <Select
                  showSearch
                  placeholder="Select member type"
                  value={memberTypeFilter}
                  onChange={(val) => setMemberTypeFilter(val)}
                  className="w-full mt-2"
                  options={memberOptions}
                  optionFilterProp="label"
                  filterOption={(input, option) => {
                    const label = option?.label?.toLowerCase() || "";
                    const mobile = option?.mobile?.toLowerCase() || "";

                    return (
                      label.includes(input.toLowerCase()) ||
                      mobile.includes(input.toLowerCase())
                    );
                  }}
                />
              </div>
            )}
            {searchcolumn == "bbps.status" && (
              <div className="w-full">
                <p className="required text-textGray mt-2">Select Status</p>
                <Select
                  placeholder="Select search type"
                  value={searchdropdown}
                  onChange={(val) => setSearchdropdown(val)}
                  className="w-full mt-2"
                  options={dropdown}
                />
              </div>
            )}
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-between items-center mt-3">
            {/* <p
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center p-2 rounded-md  hover:bg-primaryhover bg-primary border-none"
            >
              <p>Total Amount : ₹ {totalAmt ?? 0}</p>
            </p> */}
            <CommonAmountPage amountData={amountData} />
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={"BBPS Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          data={result}
        />
      )}
    </>
  );
};

export default BbpsReport;
